

























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { NotificationState } from '../store/notification';

const NotificationStore = namespace('notifications');

@Component({
  name: 'SgsNotificationComponent',
})
export default class SgsNotificationComponent extends Vue {
  @NotificationStore.Getter
  public notificationState!: NotificationState;
}

Vue.component('sgs-notification', SgsNotificationComponent);
